<script setup lang="ts">
import type { HTMLAttributes } from 'vue';

const props = defineProps<{
  class?: HTMLAttributes['class'];
}>();
</script>

<template>
  <div :class="cn('rounded-xl border bg-card p-2 text-card-foreground shadow', props.class)">
    <slot />
  </div>
</template>
